import { createSelector } from 'reselect';

export const routerSelector = (state) => state.router;

export const currentPathnameSelector = createSelector(routerSelector, (state) => state.location.pathname);
